import { Component, Input, OnInit } from '@angular/core';
import { ChartConfig, MultiChartValue } from 'src/interfaces/dashboard';

@Component({
    selector: 'core-medicine-report',
    templateUrl: './medicine-report.component.html',
    styleUrls: ['./medicine-report.component.scss'],
    standalone: false
})
export class MedicineReportComponent implements OnInit {
  @Input() heading: string;
  @Input() data: MultiChartValue[];
  @Input() config: ChartConfig;
  view: [number, number] = [900, 300];
  constructor() { }

  ngOnInit(): void {
  }

  onSelect(event: any) {
  }

}
